import React from 'react';

import 'sass/payment/PaymentMethodRadio.scss';

const icons = {
    cc: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="2" y="5" width="20" height="14" rx="2"/>
            <line x1="2" y1="10" x2="22" y2="10"/>
        </svg>
    ),
    bank: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <line x1="3" y1="21" x2="21" y2="21"/>
            <line x1="5" y1="21" x2="5" y2="10"/>
            <line x1="10" y1="21" x2="10" y2="10"/>
            <line x1="14" y1="21" x2="14" y2="10"/>
            <line x1="19" y1="21" x2="19" y2="10"/>
            <polygon points="12 2 21 8 3 8"/>
        </svg>
    ),
};

const PaymentMethodRadio = ({value, name, checked, onSelect}) => (
    <div
        className={'payment-method-radio' + (checked ? ' selected' : '')}
        onClick={() => onSelect(value)}
    >
        <input
            type="radio"
            name="paymentMethod"
            id={`payment-method-${value}`}
            value={value}
            checked={checked}
            readOnly
        />
        <label htmlFor={`payment-method-${value}`}>
            {icons[value]}
            <span>{name}</span>
        </label>
    </div>
);

export default PaymentMethodRadio;


// WEBPACK FOOTER //
// ./src/components/payment/PaymentMethodRadio.js